import { RouteConfig } from 'vue-router'

export const lectureIntro: RouteConfig = {
  path: '/lecture-intro',
  name: 'lecture_intro',
  component: () => import('@/views/lecture-auth/Intro.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '讲师团',
  },
}

export const lectureApplyIntro: RouteConfig = {
  path: '/lecture-apply',
  name: 'lecture_apply',
  component: () => import('@/views/lecture-auth/ApplyLecture.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '讲师团',
  },
}
export default [lectureIntro, lectureApplyIntro]
